/* ConvertBoost© */
cmmSetupConvertBoost({
  cta_options: [
    {
      mode: 'modal',
      icon: 'phone',
      icon_size: 'wti',
      color: '#000',
      text_shadow: '2px 2px 2px rgba(0,0,0,.2)',
      devices: ['desktop', 'laptop', 'tablet', 'mobile'],
      class_list: ['cmm-verical-cb'],
    },
  ],
  modal_options: {
    header_text:
      '<img style="margin-top:10px;max-width:300px;" src="https://lirp.cdn-website.com/c72601db/dms3rep/multi/opt/blindandshutterlogo-342w.jpg">',
    header_color: '#ffffff',
    description_text:
      'Ready to transform your Nashville home? Contact us today!',
    font: {
      family: 'AUTO',
    },
    buttons: [
      {
        title: '(615) 221-9999',
        description: 'NASHVILLE SHOWROOM',
        link: 'tel:+16152219999',
        txt_color_hover: '#0E233E',
        bg_color: '#0E233E',
        class_list: ['call-us-nashville'],
        icon: 'phone',
      },
      {
        title: '(615) 922-0292',
        description: 'FRANKLIN SHOP-AT-HOME',
        link: 'tel:+16159220292',
        txt_color_hover: '#0E233E',
        bg_color: '#0E233E',
        class_list: ['call-us-franklin'],
        icon: 'phone',
      },
      {
        title: 'TEXT US',
        link: 'sms:+16158808851',
        txt_color_hover: '#0E233E',
        bg_color: '#0E233E',
        class_list: ['text-us'],
        icon: 'sms-solid',
      },
      {
        title: 'VISIT SHOWROOM',
        link: 'https://www.google.com/maps/place/Blind+%26+Shutter+Gallery+of+Nashville/@36.1037811,-86.7582704,793m/data=!3m2!1e3!4b1!4m6!3m5!1s0x88647bdfff9ae13f:0xa612fa399c768e8a!8m2!3d36.1037769!4d-86.7533995!16s%2Fg%2F1tf08d6x?entry=ttu&g_ep=EgoyMDI1MDQyOC4wIKXMDSoJLDEwMjExNDUzSAFQAw%3D%3D',
        link_target: '_blank',
        txt_color_hover: '#0E233E',
        bg_color: '#0E233E',
        class_list: ['visit-showroom'],
        icon: 'map-pin',
      },
      {
        title: 'CONTACT',
        link: '/contact',
        bg_color: '#0E233E',
        txt_color_hover: '#0E233E',
        class_list: ['contact'],
        icon: 'email',
      },
    ],
    footer_text:
      'Blind & Shutter Gallery proudly serves the greater Nashville, TN area with custom Hunter Douglas blinds, shades, shutters, drapery, and more. Book your personal consultation today!',
    footer_color: '',
  },
}).then((_) => {
  /* ConvertBoost©  Event Tracking */
  cmmSetupEventTracking([
    {
      selector: '#cmm-call-to-action-modal .call-us-nashville',
      action: 'Call Nashville (615) 221-9999 - ConvertBoost©',
      event: 'click',
    },
  ]);
  cmmSetupEventTracking([
    {
      selector: '#cmm-call-to-action-modal .call-us-franklin',
      action: 'Call Franklin (615) 922-0292 - ConvertBoost©',
      event: 'click',
    },
  ]);
  cmmSetupEventTracking([
    {
      selector: '#cmm-call-to-action-modal .text-us',
      action: 'Text (615) 880-8851 - ConvertBoost©',
      event: 'click',
    },
  ]);
  cmmSetupEventTracking([
    {
      selector: '#cmm-call-to-action-modal .visit-showroom',
      action: 'Visit Showroom - ConvertBoost©',
      event: 'click',
    },
  ]);
  cmmSetupEventTracking([
    {
      selector: '#cmm-call-to-action-modal .contact',
      action: 'Contact - ConvertBoost©',
      event: 'click',
    },
  ]);
});
